import { Team } from "@app/shared/models/team";
import { Offer } from "@app/shared/models/offer";
import { OfferTemplate } from "@app/shared/models/offerTemplate";

export class OfferAllocation {
  id?: number;
  department?:string;
  team?:Team;
  pagePosition?:number;
  publicOffers:Offer[];
  viewTemplate:OfferTemplate;
}

// export class OfferMenuEvent{
//   type?:string;
//   offer?:Offer;
//   documentSegment?:DocumentSegment;
//   job?:Job;
// }
//
// export const OfferMenuEventType = {
//   EDIT_OFFER: 'EDIT_OFFER',
//   ADD_OFFER: 'ADD_OFFER',
//   LOCK_OFFER:'LOCK_OFFER',
//   DELETE_OFFER:'DELETE_OFFER',
//   ADD_TO_FAVE:'ADD_TO_FAVE',
//   ALLOC_OFFER:'ALLOC_OFFER',
//   COPY_OFFER:'COPY_OFFER',
//   OFFER_HISTORY:'OFFER_HISTORY',
//   REMOVE_TEMPLATE:'REMOVE_OFFER_TEMPLATE',
// };
//
// export class OfferSearchCriteria{
//   keyword?:string;
// }



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/offerAllocation.ts